module.exports = __webpack_public_path__ + "static/media/mlr_screenshot.953bab7b.png";